<template lang="pug">
div
  section.u-mt-lg
    AppTitle.u-mb-0(:title="$t('mantra')")

  .u-mb-mi

</template>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Nostalgia",
    "pageDesc":"Travel through time and explore the older versions of today's most well known companies, websites, apps and brands.",
    "mantra":"Travel through time |with custom illustration |and imagery."
  },
  "ar": {
    "pageTitle":"نوستالجيا",
    "pageDesc":"يمكنك السفر عبر الزمن واستكشاف الإصدارات الأقدم من أشهر الشركات والمواقع الإلكترونية والتطبيقات والعلامات التجارية اليوم.",
    "mantra":"سافر عبر الزمن |وشاهد عبق التاريخ |عبر رسوم مخُصصة. "
  }
}
</i18n>
